import { useEffect } from "react";

import { SupportWidget } from "hooks/useSupportWidget";
import { ServiceScript, useServiceScript } from "providers/ServicesProvider/ServiceScriptProvider";


const SCRAPERAPI_CHATBOT_SCRIPT: ServiceScript = {
  name: "ScraperAPI AI Chatbot",
  src: process.env.REACT_APP_SCRAPERAPI_AI_CHATBOT_URL!,
  domId: "scraperapi-ai-chatbot"
};

export function useScraperApiChatbot(): SupportWidget {

  const { loadServiceScript } = useServiceScript(SCRAPERAPI_CHATBOT_SCRIPT);

  useEffect(() => {
    if (process.env.REACT_APP_SUPPORT_WIDGET_USE === "scraperApi") {
      if (typeof window !== "undefined") {
        window.SUPPORT_BOT_API = process.env.REACT_APP_SCRAPERAPI_AI_CHATBOT_API_URL ?? "https://support.trajectdata.com/api";
        window.SUPPORT_BOT_TENANT = "scraper_api";
      }

      loadServiceScript();
    }
  }, [ loadServiceScript ]);


  return {
    showSupportForm: () => { window.SupportWidget?.open(); },
    hideSupportForm: () => { window.SupportWidget?.close(); },
    showSalesForm: () => {}
  };
}
